
<svg [class.opacity-0]="!visible" class="pe-none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 150" width="100%" height="150">
    <path id="sleighPath" d="M10,80 C100,10 300,150 400,80" fill="transparent" stroke="transparent" />
    <image id="sleigh" href="/assets/images/sleigh.svg" width="200" height="120" x="0" y="0" />
</svg>